<template lang="pug">
aside.main-menu.d-flex.flex-column.bg-black
  .pt-4.pb-2
    span.px-2.d-inline-block
      app-logo.size-48(ref="svgAppLogo")
    span(ref="svgAppLogoTextWrap")
      app-logo-text.w-125
  .flex-1.pos-r.main-menu-items(
    :class="{ 'is-collapsed': isMainMenuCollapsed }"
  )
    simplebar.pin.pin-xy.of-a(data-simplebar-auto-hide="true")
      el-menu.d-flex.flex-column(
        :default-active="activeMenuItem",
        :collapse="isMainMenuCollapsed",
        background-color="#000",
        text-color="#bbb",
        active-text-color="#fff",
        :unique-opened="true",
        @select="handleSelectMenu"
      )
        <!--el-menu-item(index="/", :class="isMenuActive('/')")-->
          <!--font-awesome-icon.el-icon-for-fa.fs-14(:icon="['fal', 'tachometer-slow']")-->
          <!--span(slot="title") Dashboard-->

        el-menu-item(index=`/meetings`, v-if="companyScoped" :class="isMenuActive('meetings')")
          font-awesome-icon.el-icon-for-fa.fs-14(:icon="['fal', 'sitemap']")
          span(slot="title") Meetings

        el-menu-item(index=`/teams`, v-if="companyScoped" :class="isMenuActive('teams')")
          font-awesome-icon.el-icon-for-fa.fs-14(:icon="['fal', 'sitemap']")
          span(slot="title") Teams

        el-menu-item(index=`/users`, v-if="companyScoped" :class="isMenuActive('users')")
          font-awesome-icon.el-icon-for-fa.fs-14(:icon="['fal', 'users']")
          span(slot="title") Users
        template(v-if="isSuperAdmin && companyScoped")
          hr
        el-menu-item(index=`/companies`, v-if="isSuperAdmin" :class="isMenuActive('companies')")
          font-awesome-icon.el-icon-for-fa.fs-14(:icon="['fal', 'building']")
          span(slot="title") Companies
</template>

<script>
import { gsap } from 'gsap';
import { mapGetters } from 'vuex';

import AppLogo from '@/components/logos/AppLogo.vue';
import AppLogoText from '@/components/logos/AppLogoText.vue';

export default {
  name: 'AppMainMenu',
  components: { AppLogo, AppLogoText },

  data() {
    return {
      activeMenuItem: null,
      subMenuItems: [
        {
          title: 'Employees',
          slug: 'employees',
          icon: 'user-tie',
        },
        {
          title: 'Team',
          slug: 'teams',
          icon: 'users',
          hasGroupPg: true,
        },
      ],
    };
  },

  computed: {
    ...mapGetters('shared', ['isMainMenuCollapsed']),
    ...mapGetters('groupSelected', ['groupSelectedInfo']),
    ...mapGetters('users', ['me', 'scopedCompany', 'isSuperAdmin']),

    companyScoped() {
      // return !this.isSuperAdmin && this.scopedCompany || this.scopedCompany
      return this.scopedCompany;
    },
    companyId() {
      return this.scopedCompany.id;
    },
  },

  watch: {
    $route(newVal) {
      // console.log(newVal);
      this.activeMenuItem = newVal.path;
    },
    isMainMenuCollapsed: 'initLogoAnim',
  },

  mounted() {
    this.activeMenuItem = this.$route.path;
  },

  methods: {
    initLogoAnim() {
      const { svgAppLogoTextWrap } = this.$refs;
      const timeline = gsap.timeline();
      if (this.isMainMenuCollapsed) {
        timeline.to(svgAppLogoTextWrap, 0.15, { autoAlpha: 0, display: 'none' });
      } else {
        timeline
          .set(svgAppLogoTextWrap, { autoAlpha: 0, display: 'none' })
          .to(svgAppLogoTextWrap, 0.3, { autoAlpha: 1, display: 'inline' }, 0.3);
      }
    },

    isMenuActive(route) {
      if (this.$route.path === route) return 'is-active';
      return '';
    },

    handleSelectMenu(key) {
      // available perms: key, keyPath
      if (this.$route.path === key) return;
      this.$router.push(key);
    },

  },
};
</script>
